import BaseMixin from "@/mixins/http/Base";
import { Component } from "vue-property-decorator";
import { API_ENDPOINT } from "@/constants";

export const GET_AGENT_MODULE_CONFIGURATION = "GET_AGENT_MODULE_CONFIGURATION";

export const enum AgentModuleConfigurationMixinTags {
  GetAgentModuleConfiguration = "get_agent_module_configuration",
}

@Component
export default class AgentModuleConfigurationMixin extends BaseMixin {
  getAgentModuleConfiguration(tag: string, profileSlug: string): Promise<any> {
    const url =
      API_ENDPOINT + `/${profileSlug}/agents/agent_module_configurations.json?`;

    return this.$store.dispatch("http/request", {
      tag: tag,
      url: url,
      method: "GET",
    });
  }
}
